import TransitionTextBlock from './TransitionTextBlock';

export default TransitionTextBlock;
